import SplitPhotos from './SplitPhotosContainer';

export default SplitPhotos;
